import DataGridStyled from "./StyledGrid";
export default DataGridStyled;